//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { BenefitWithIcon } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
import { ComplainceIcon, OperationsIcon, RevenueIcon } from '@cmp/images';
//------------------------------------------------------------------------------
// Constsants ----------------------------------------------------------------------
const BENEFITS = [
  {
    icon: <ComplainceIcon />,
    textI18nKey: 'landing_HelpsYouProvide',
  },
  {
    icon: <OperationsIcon />,
    textI18nKey: 'landing_ReclaimTime',
  },
  {
    icon: <RevenueIcon />,
    textI18nKey: 'landing_EarnRewards',
  },
];
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class BenefitWithIconGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { className, t } = this.props;
    const componentClasses = classNames(styles.BenefitWithIconGroup, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        {BENEFITS.map((benefit, index) => (
          <BenefitWithIcon
            key={`benefit-with-icon-${index}`}
            icon={benefit.icon}
            alt={t(benefit.textI18nKey)}
            text={t(benefit.textI18nKey)}
            className={styles.BenefitWithIcon}
          />
        ))}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(BenefitWithIconGroup);
